module.exports = " <div class=vc-page> <header-bar> <icon-button slot=left @click=back() icon=arrow_back></icon-button> <span>Infinite Scroll</span> </header-bar> <scroll-view v-el:scroller> <content-block> <p class=refresh-desc> 向下滑动可以加载更多的数据 </p> </content-block> <list> <item-cell v-for=\"item in items\"> <item-title> {{item}} </item-title> </item-cell> </list> <infinite-scroll :trigger=$els.scroller @load=loadMore :loading=loading></infinite-scroll> </scroll-view> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src-examples/views/infiniteScroll.vue
 ** module id = 397
 ** module chunks = 1
 **/